import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('lang-toggler', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('lang-toggler');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
